import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { App } from './App';
import { RootErrorBoundary } from '@/components/errors/root-error-boundary';
import { env } from '@/lib/env';
import { buildSentryInitOptions } from '@/lib/observability/sentry-init';
import '@/styles/globals.css';

if (env.sentry.dsn !== undefined) Sentry.init(buildSentryInitOptions(env.sentry.dsn));

const container = document.getElementById('root');

if (!container) throw new Error('Missing #root element in index.html');

createRoot(container).render(
  <StrictMode>
    <RootErrorBoundary>
      <App />
    </RootErrorBoundary>
  </StrictMode>,
);
